/**
 * Core Opacity Tokens — Tier 1
 *
 * Raw opacity scale (0–1).
 * JS key maps to Figma token: opacity[8] → opacity-8 (key = percentage value).
 *
 * Rules:
 * - Tier 2 semantic tokens reference these keys; never raw values
 */

export const opacity = {
  0: 0,
  8: 0.08,
  12: 0.12,
  38: 0.38,
  50: 0.5,
  56: 0.56,
  100: 1,
} as const;

export type Opacity = typeof opacity;
export type OpacityToken = keyof Opacity;
